export default {
  computed: {
    isLivingAddressComplete() {
      if (this.isAddressLivingAndRegistrationTheSame) {
        return true;
      }

      const address = this.living_address;

      return !!(String(address.locality || '').trim() && String(address.street || '').trim());
    },
    isAddressDataIncorrect() {
      return this.isAddressLivingAndRegistrationTheSame
        ? !this.userData.address_str
        : (!this.userData.address_str || !this.isLivingAddressComplete);
    },
  },
};